import React, { useState } from 'react';
import Avatar from '../common/Avatar';
import { formatRelativeTime } from '../../utils/helpers';

const CommentPin = ({ comment, position }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="absolute"
      style={{
        left: `${position.x}%`,
        top: `${position.y}%`,
      }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {/* Pin Marker */}
      <div className="relative -ml-4 -mt-4">
        <button className={`w-8 h-8 border-2 border-white rounded-full shadow-lg flex items-center justify-center text-white text-xs font-bold transition-colors ${
          comment.is_internal 
            ? 'bg-purple-500 hover:bg-purple-600' 
            : 'bg-red-500 hover:bg-red-600'
        }`}>
          {comment.is_internal ? '🔒' : '💬'}
        </button>

        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute z-10 bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64">
            <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-3">
              {/* Arrow */}
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-px">
                <div className="border-8 border-transparent border-t-white"></div>
              </div>

              {/* User Info */}
              <div className="flex items-start space-x-2 mb-2">
                <Avatar name={comment.user_name} imageUrl={comment.avatar_url} size="sm" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900">
                    {comment.user_name}
                  </p>
                  <p className="text-xs text-gray-500">
                    {formatRelativeTime(comment.created_at)}
                  </p>
                </div>
              </div>

              {/* Comment Text */}
              <p className={`text-sm mb-2 ${comment.is_internal ? 'text-gray-600 italic' : 'text-gray-700'}`}>
                {comment.comment_text}
              </p>

              {/* Badges */}
              <div className="flex items-center gap-2 flex-wrap">
                {comment.is_internal && (
                  <span className="inline-block px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full font-medium">
                    🔒 Internal
                  </span>
                )}
                {comment.is_resolved && (
                  <span className="inline-block px-2 py-1 bg-green-100 text-green-800 text-xs rounded">
                    ✓ Resolved
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentPin;


